import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="pricing" className="py-24 px-4 bg-[#112240]/30 border-t border-slate-800/50 relative" data-id="element-173">
      <div className="max-w-5xl mx-auto" data-id="element-174">
        {/* Urgency Section */}
        <div className="max-w-2xl mx-auto text-center mb-16" data-id="element-175">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 flex items-center justify-center gap-2" data-id="element-176">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>

          <div className="mb-6" data-id="element-177">
            <CountdownTimer data-id="element-178" />
          </div>

          <p className="text-red-400 font-medium flex items-center justify-center gap-2 mb-8 bg-red-500/10 py-2 px-4 rounded-lg inline-flex" data-id="element-179">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <div className="bg-[#0a1628] p-4 rounded-xl border border-slate-700" data-id="element-180">
            <div className="flex justify-between text-sm font-bold mb-2" data-id="element-181">
              <span className="text-white flex items-center gap-2" data-id="element-182">
                🔴 68% de los cupos al precio de lanzamiento ya tomados
              </span>
            </div>
            <div className="w-full bg-slate-800 rounded-full h-3 overflow-hidden" data-id="element-183">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-gradient-to-r from-red-500 to-red-400 h-full rounded-full relative" data-id="element-184">
                <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-185" />
              </motion.div>
            </div>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-186">
          <h2 className="text-4xl font-bold text-white" data-id="element-187">ELEGÍ TU MEGAPACK</h2>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-188">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#0a1628] rounded-3xl p-8 border border-slate-700 flex flex-col hover:border-slate-500 transition-colors" data-id="element-189">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-190">
              📘 MEGAPACK EMPLEO
            </h3>
            <p className="text-slate-400 mb-6 min-h-[48px]" data-id="element-191">
              6 Tomos + 6 Bonos
              <br data-id="element-192" />
              Para cualquier nivel e industria
            </p>

            <div className="mb-8 mt-auto" data-id="element-193">
              <div className="text-slate-500 line-through text-xl mb-1" data-id="element-194">
                $51.000
              </div>
              <div className="text-4xl font-extrabold text-white" data-id="element-195">
                $19.990{' '}
                <span className="text-xl text-slate-400 font-medium" data-id="element-196">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBNOeyViHxBp01K3QlTvRC/es-ar?_r=AQABNwbY0Gh65dKT0iNCmZoIeXDQOtoAfeVxOclTzMPzkYY&cart_link_id=LFw4kxNu&locale=es-AR&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 rounded-xl font-bold text-white bg-slate-800 hover:bg-slate-700 transition-colors border border-slate-600 text-center block" data-id="element-197">
              → QUIERO MI MEGAPACK
            </a>
          </motion.div>

          {/* Card 2 - Highlighted */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gradient-to-b from-[#1a2b4c] to-[#0a1628] rounded-3xl p-8 border-2 border-[#d4a843] flex flex-col relative shadow-[0_0_40px_rgba(212,168,67,0.15)] transform md:-translate-y-4" data-id="element-198">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#d4a843] text-[#0a1628] font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider whitespace-nowrap" data-id="element-199">
              Más elegido
            </div>

            <h3 className="text-2xl font-bold text-[#d4a843] mb-2 flex items-center gap-2" data-id="element-200">
              🏆 MEGAPACK + EL CIERRE ⭐
            </h3>
            <p className="text-slate-300 mb-6 min-h-[48px]" data-id="element-201">
              6 Tomos + 6 Bonos +{' '}
              <span className="font-bold text-white" data-id="element-202">
                Manual de Entrevistas y Negociación Salarial
              </span>
              <br data-id="element-203" />
              Para quien quiere cerrar la oferta, no solo conseguir la
              entrevista
            </p>

            <div className="mb-8 mt-auto" data-id="element-204">
              <div className="text-slate-500 line-through text-xl mb-1" data-id="element-205">
                $69.000
              </div>
              <div className="text-5xl font-extrabold text-white" data-id="element-206">
                $27.990{' '}
                <span className="text-xl text-slate-400 font-medium" data-id="element-207">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBNOo9QfhEt997K4x7J562/es-ar?_r=AQABGM9sVLA-y5M-I173QUPjN_LkGUrugrINcAmg5RC5eYA&cart_link_id=evhI4N6d&locale=es-AR&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 rounded-xl font-bold text-[#0a1628] bg-gradient-to-r from-[#d4a843] to-[#fcebb6] hover:scale-[1.02] transition-transform shadow-lg text-center block" data-id="element-208">
              → QUIERO EL MEGAPACK + EL CIERRE
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}